module.exports = __webpack_public_path__ + "img/65.3c18e19d.png";